import { useState, useCallback } from 'react';

const useFormValidation = () => {
    const [errors, setErrors] = useState({});

    const validateForm = useCallback((formData) => {
        const newErrors = {};

        if (!formData.bank_name) {
            newErrors.bank_name = 'Bank name is required';
        }

        if (!formData.bank_account_number) {
            newErrors.bank_account_number = 'Account number is required';
        }

        if (!formData.ifsc) {
            newErrors.ifsc = 'IFSC code is required';
        } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.ifsc)) {
            newErrors.ifsc = 'Invalid IFSC code';
        }

        if (!formData.city) {
            newErrors.city = 'City is required';
        }

        if (!formData.state) {
            newErrors.state = 'State is required';
        }

        if (!formData.otp) {
            newErrors.otp = 'OTP is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }, []);

    const clearError = useCallback((fieldName) => {
        if (errors[fieldName]) {
            setErrors(prev => ({ ...prev, [fieldName]: '' }));
        }
    }, [errors]);

    const setError = useCallback((fieldName, message) => {
        setErrors(prev => ({ ...prev, [fieldName]: message }));
    }, []);

    const clearAllErrors = useCallback(() => {
        setErrors({});
    }, []);

    return {
        errors,
        validateForm,
        clearError,
        setError,
        clearAllErrors
    };
};

export default useFormValidation;
